import React, { Component,useEffect } from 'react';
import { connect } from "react-redux";
import FilterVariable from "./FilterVariable";
import DateFilter from "./components/DateFilter";
import AgentFilter from "./components/AgentFilter";
import RatingFilter from "./components/RatingFilter";
import DepartmentFilter from "./components/DepartmentFilter";
import AssignmentFilter from "./components/AssignmentFilter";
import { ArrayParam, StringParam,withQueryParams } from 'use-query-params';

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})


class Filter extends Component {

    constructor(props) {
        super(props);
        var filterItems = [
            { name:"Date",icon:"bx bx-calendar", cshow:false },
            { name:"Agent",icon:"bx bx-user" },
            { name:"Department",icon:"bx bx-grid-small" },
            { name:"Assignment",icon:"bx bx-user" },
            { name:"Rating",icon:"fa fa-thumbs-up" },
        ];

        this.state = {
            filterItems: filterItems,
            filterVariable:false,
            selectedFilter: []
        };



        this.openFilterVariable=this.openFilterVariable.bind(this);
        this.selectFilter=this.selectFilter.bind(this);
        this.changeShowIs=this.changeShowIs.bind(this);
        this.closeFilter=this.closeFilter.bind(this);
    }

    componentDidMount() {

        if(typeof this.props.query.date_from!=="undefined" && typeof this.props.query.date_to!=="undefined"){

            const last=this.state.selectedFilter;
            var joined = {};
            joined.name="Date";
            joined.showis=true;
            last.push(joined);

            this.setState({
                selectedFilter:last
            });
        }
        if(typeof this.props.query.agents!=="undefined"){

            const last=this.state.selectedFilter;
            var joined = {};
            joined.name="Agent";
            joined.showis=true;
            last.push(joined);

            this.setState({
                selectedFilter:last
            });
        }

        if(typeof this.props.query.department!=="undefined"){

            const last=this.state.selectedFilter;
            var joined = {};
            joined.name="Department";
            joined.showis=true;
            last.push(joined);

            this.setState({
                selectedFilter:last
            });
        }


        if(typeof this.props.query.rate!=="undefined"){

            const last=this.state.selectedFilter;
            var joined = {};
            joined.name="Rating";
            joined.showis=true;
            last.push(joined);

            this.setState({
                selectedFilter:last
            });
        }
        if(typeof this.props.query.agent_assignment!=="undefined"){

            const last=this.state.selectedFilter;
            var joined = {};
            joined.name="Assignment";
            joined.showis=true;
            last.push(joined);

            this.setState({
                selectedFilter:last
            });
        }

    }

    selectFilter(e,name){

            if (this.state.filterVariable==true) {
                this.openFilterVariable();
            }



            if(typeof this.state.selectedFilter.find(element => element.name == name)==="undefined"){

                const last=this.state.selectedFilter;
                var joined = {};
                joined.name=name;
                joined.showis=false;
                last.push(joined);

                this.setState({
                    selectedFilter:last
                });

            } else{
                this.changeShowIs(false,name);
            }



    }
    closeFilter(name){

        if(typeof this.state.selectedFilter.find(element => element.name == name)!=="undefined"){

            for (var values in this.state.selectedFilter) {
                if (this.state.selectedFilter[values].name == name) {
                    this.state.selectedFilter.splice(values,1);
                }
            }

            this.setState({
                selectedFilter: this.state.selectedFilter
            });
        }
    }
    openFilterVariable(){

        if (!this.state.filterVariable) {
            document.addEventListener("click", this.handleOutsideClick, false);
        } else {
            document.removeEventListener("click", this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            filterVariable: !prevState.filterVariable
        }));

    }

    handleOutsideClick = e => {
        if (!this.node.contains(e.target)) this.openFilterVariable();
    };

    changeShowIs(state,name){
        if(typeof this.state.selectedFilter.find(element => element.name == name)!=="undefined"){
            Object.keys(this.state.selectedFilter).forEach(t=>{
               if(this.state.selectedFilter[t].name==name){
                   this.state.selectedFilter[t].showis=state;
               }
            });
            this.setState({
                selectedFilter: this.state.selectedFilter
            });
        }
    }
    render() {
        const { t } = this.props;

        return (

            <div className="filter-container">
            <div
                className="filter-item"
                ref={node => {
                this.node = node;
            }}>
                <button
                    onClick={this.openFilterVariable}
                    className="filter-button">
                    <i className='bx bx-plus'></i>
                    <span>Add Filter</span>
                </button>
                {this.state.filterVariable === true &&

                        <FilterVariable
                            selectFilter={this.selectFilter}
                            stateFilter={this.state.filterItems}
                            propFilter={this.props.filterItems}/>

                }

            </div>
            {Object.keys(this.state.selectedFilter).map(key=> {
                if(this.state.selectedFilter[key].name=="Date"){

                    return <DateFilter filtering={this.props.filtering}
                                       closeFilter={this.closeFilter}
                                       changeShowIs ={this.changeShowIs}
                                       showis={this.state.selectedFilter[key].showis}
                                       filterDetail={this.state.filterItems.filter(f=>f.name==this.state.selectedFilter[key].name)[0]}
                    />;
                }
                if(this.state.selectedFilter[key].name=="Agent"){

                    return <AgentFilter
                        filtering={this.props.filtering}
                        closeFilter={this.closeFilter}
                        changeShowIs ={this.changeShowIs}
                        showis={this.state.selectedFilter[key].showis}
                        filterDetail={this.state.filterItems.filter(f=>f.name==this.state.selectedFilter[key].name)[0]}

                    />;
                }
                if(this.state.selectedFilter[key].name=="Department"){

                    return <DepartmentFilter
                        filtering={this.props.filtering}
                        closeFilter={this.closeFilter}
                        changeShowIs ={this.changeShowIs}
                        showis={this.state.selectedFilter[key].showis}
                        filterDetail={this.state.filterItems.filter(f=>f.name==this.state.selectedFilter[key].name)[0]}

                    />;
                }
                if(this.state.selectedFilter[key].name=="Assignment"){

                    return <AssignmentFilter
                        filtering={this.props.filtering}
                        closeFilter={this.closeFilter}
                        changeShowIs ={this.changeShowIs}
                        showis={this.state.selectedFilter[key].showis}
                        filterDetail={this.state.filterItems.filter(f=>f.name==this.state.selectedFilter[key].name)[0]}

                    />;
                }
                if(this.state.selectedFilter[key].name=="Rating"){

                    return <RatingFilter
                        filtering={this.props.filtering}
                        closeFilter={this.closeFilter}
                        changeShowIs ={this.changeShowIs}
                        showis={this.state.selectedFilter[key].showis}
                        filterDetail={this.state.filterItems.filter(f=>f.name==this.state.selectedFilter[key].name)[0]}

                    />;
                }

            })}
            </div>
        );
    }
}




export default
    withQueryParams(
        {
            date_from: StringParam,
            date_to: StringParam,
            agents: ArrayParam,
            department: ArrayParam,
            agent_assignment: StringParam,
            rate: StringParam
        },
        Filter);
